<template>
    <div>
        <v-dialog
            v-model="display"
            persistent
            width="500">
            <v-card flat>
                <v-card-title>{{ title }}</v-card-title>
                <v-card-text>
                    <v-form
                        v-model="valid"
                        ref="form">
                        <v-text-field
                            v-model="form.name"
                            :label="$t('bank_name')"
                            :rules="rules.required"
                            dense>
                        </v-text-field>
                        <p-currency-select 
                            :rules="rules.required"
                            v-model="form.currency_id">
                        </p-currency-select>
                        <v-select
                            dense
                            v-model="form.bank_account_type_id"
                            :rules="rules.required"
                            :items="type"
                            :menu-props="{down: true,offsetY: true}"
                            item-text="name"
                            item-value="value"
                            :label="$t('type_account')"
                            clearable
                            @click:clear="form.bank_account_type_id = null">
                        </v-select>
                        <v-select
                            v-if="isBank"
                            dense
                            v-model="form.bank_account_name_id"
                            :menu-props="{down: true,offsetY: true}"
                            item-text="name"
                            item-value="value"
                            :label="$t('bank')"
                            clearable
                            @click:clear="form.bank_account_name_id = null">
                        </v-select>
                        <v-text-field
                            v-if="isBank"
                            dense
                            v-model="form.account_number"
                            :label="$t('account_no')">
                        </v-text-field>
                        <account-search 
                            v-for="(account, index) in accounts" 
                            :key="index" 
                            :rules="rules[account.rules]"
                            :id-account="form[account.account]" 
                            :label="account.label" 
                            v-model="form[account.account]">
                        {{ form[account.account] }}
                        </account-search>
                        {{ $t('status')}}: <v-switch v-model="form.active" :label="$t('active')"></v-switch>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <!-- :disabled="!valid" -->
                    <v-btn @click="submit" :disabled="!valid" :loading="loading.submit" text>{{ $t('save_btn') }}</v-btn>
                    <v-btn @click="close" text>{{ $t('close_btn') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <retry-dialog
            ref="retryDialog"
            @submit="onRetryDialogSubmit">
        </retry-dialog>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import service from '../../services/service';
import PCurrencySelect from '../common/PCurrencySelect.vue';
import RetryDialog from '../common/RetryDialog.vue';
import AccountSearch from './AccountSearch.vue';
export default {
    name:'BankAccountDialog',
    components: {PCurrencySelect, AccountSearch,RetryDialog},
    props: {
        id: Number,
    },
    data() {
        return {
            display: true,
            valid: false,
            form: {
                name: null,
                bank_account_type_id: null,
                bank_account_name_id: null,
                currency_id: null,
                inactive: false,
                ledger_id: null,
                bank_charges_ledger_id: null,
                cheque_under_collection_ledger_id: null,
                transfer_suspense_ledger_id: null
            },
            rules: {
                required: [
                    v => !!v || this.$t('rules_required')
                ]
            },
            type: [
                { name: 'Cash', value: 1 },
                { name: 'Checking Account', value: 2 },
                { name: 'Saving Account', value: 3 },
            ],
            types: [],
            loading: {
                data: false,
                submit: false
            }
        }
    },
    computed: {
        notEditMode() {
            return !this.id;
        },
        editMode() {
            return !this.notEditMode;
        },
        title() {
            if(this.notEditMode) return this.$t('new_bank_account');
            else return this.$t('edit_bank_account');
        },
        isBank() {
            if(this.form.bank_account_type_id == 3) return true;
            else return false;
        },
        accounts() {
            switch(this.form.bank_account_type_id) {
                case 1: 
                // console.log('cash', 'true')
                    return [
                        { account: 'ledger_id', rules: 'required' }, 
                        { account: 'cheque_under_collection_ledger_id' ,label: 'chequeue_under_collection_account'},
                    ];
                case 2: 
                    // console.log('saving', 'true')
                    return [
                        { account: 'ledger_id', rules: 'required' }, 
                        { account: 'bank_charges_ledger_id', label: 'bank_charges_account' },
                                
                    ];
                case 3: 
                    return [
                        { account: 'ledger_id', rules: 'required' },
                        { account: 'transfer_suspense_ledger_id', label: 'bank_transfer_suspense_account'},
                        { account: 'bank_charges_ledger_id', label: 'bank_charges_account' }
                        // { account: 'cheque_under_collection_ledger_id' ,label: 'chequeue_under_collection_account', rules: 'required'}
                    ];
                default :
                    return [
                        { account: 'ledger_id', rules: 'required' }
                    ];
            }
        }
    },
    methods: {
        ...mapActions('common/snackBar', ["setSnackBars"]),
        async createdDataFetch() {
            try {
                await Promise.all([this.getAccountType]);
                if(this.editMode) {
                    let response = await service('/banking/bank-accounts/'+this.id, 'get');
                    this.form = response.data;
                }
                
            } catch(error) {
                let message = error.response ? error.response.data.message : error;
                this.$refs.retryDialog.open({target:"createdDataFetch",message});
            }
        },
        async getAccountType() {
            let result = await service('accounting/account-actives', 'get');
            this.types = result.data;
        },
        async getBanks() {
            let result = await service('');
            this.banks = result.data;
        },
        onRetryDialogSubmit(params){
            if(params.target == "createdDataFetch") {
                if(params.retry) this.createdDataFetch();
            }
        },
        submit() {
            this.loading.submit = true;
            if(this.notEditMode) {
                service('/banking/bank-accounts', 'post', this.form)
                    .then(() => {
                        this.loading.submit = false;
                        this.setSnackBars({ message: this.$t('record_save_success') });
                        this.$emit('update');
                        this.close();
                    })
                    .catch((error) => {
                        this.loading.submit = false;
                        let message = error.response ? error.response.data.message : error;
                        this.setSnackBars({ color: 'error', message });
                    })
            } else {
                service('banking/bank-accounts/'+this.id, 'put', this.form)
                    .then(() => {
                        this.loading.submit = false;
                        this.setSnackBars({ message: this.$t("record_update_success") });
                        this.$emit('update');
                        this.close();
                    })
                    .catch((error) => {
                        this.loading.submit = false;
                        let message = error.response ? error.response.data.message : error;
                        this.setSnackBars({ color: 'error', message });
                    })
            }
        },
        close() {
            this.$emit('close');
        }
    },
    created() {
        this.createdDataFetch();
    }
}
</script>

<style>

</style>